import { Controller } from "@hotwired/stimulus"
import { requireNotNull } from "~/types/types.util"

// Connects to data-controller="password-visibility"
export default class extends Controller<HTMLElement> {
  static targets = ["icon"]
  static classes = ["hidden"]
  declare hasHiddenClass: boolean
  declare hiddenClass: string
  declare class: string
  declare hidden: boolean

  declare iconTargets: HTMLElement[]

  get inputTarget(): HTMLInputElement {
    return requireNotNull(this.element.querySelector<HTMLInputElement>(":scope input"),
      "An input is required for password visibility controller to work.")
  }

  connect(): void {
    this.hidden = this.inputTarget.type === "password"
    this.class = this.hasHiddenClass ? this.hiddenClass : "hidden"
  }

  toggle(e: Event): void {
    e.preventDefault()

    this.inputTarget.type = this.hidden ? "text" : "password"
    this.hidden = !this.hidden

    this.iconTargets.forEach((icon) => icon.classList.toggle(this.class))
  }
}
